module.exports = __webpack_public_path__ + "08156b44ae1f38381661c1c6bb019a39.png";